import {SvgIconData} from '@shared_web/components/core/svg_icon';

export const icon_bar_chart: SvgIconData = {
  viewBox: '0 0 24 24',
  element: (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="miter"
    >
      <line x1="22" y1="3" x2="22" y2="21" />
      <line x1="17" y1="7" x2="17" y2="21" />
      <line x1="12" y1="11" x2="12" y2="21" />
      <line x1="7" y1="14" x2="7" y2="21" />
      <line x1="2" y1="17" x2="2" y2="21" />
    </g>
  ),
};
